module.exports = __webpack_public_path__ + "img/icon_vcard_blue.60abf33.svg";